import React from 'react';
import ReactPlayer from 'react-player';
import { MediaPlayerProps } from '@business/interfaces/photo';
import { SkeletonImage } from '../Photos/SkeletonImage';

const MediaPlayer: React.FC<MediaPlayerProps> = ({
  type,
  src,
  alt = 'Media content',
  className = '',
  containerClassName = '',
  controls = true,
  autoPlay = false,
  muted = false,
  loop = false,
  width = '100%',
  height = '100%',
  onPlay,
  onPause,
  onEnded,
  onImageLoad,
  onError
}) => {
  if (type === 'image') {
    return (
      <div className={`relative ${containerClassName}`}>
        <SkeletonImage
          src={src}
          alt={alt}
          className="min-h-96 w-full"
          imgClassName={`w-full h-full object-cover ${className}`}
          onImageLoad={onImageLoad}
          onError={onError}
        />
      </div>
    );
  }

  // type === 'video'
  return (
    <div className={`relative ${containerClassName}`}>
      <ReactPlayer
        {...({
          src,
          width,
          height,
          playing: autoPlay,
          controls,
          muted,
          loop,
          onPlay,
          onPause,
          onEnded,
          onError,
          className,
          style: { objectFit: 'cover' }
        } as any)}
      />
    </div>
  );
};

export default MediaPlayer;
